var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonTeachingStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53125 2.6875C4.06526 2.6875 3.6875 3.06526 3.6875 3.53125V8.59375C3.6875 9.05974 3.30974 9.4375 2.84375 9.4375C2.37776 9.4375 2 9.05974 2 8.59375V3.53125C2 2.13328 3.13328 1 4.53125 1H9.59375C10.0597 1 10.4375 1.37776 10.4375 1.84375C10.4375 2.30974 10.0597 2.6875 9.59375 2.6875H4.53125Z",
    fill: "#FFBB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 1.84375C20.5625 1.37776 20.9403 1 21.4062 1H26.4688C27.8667 1 29 2.13328 29 3.53125V8.59375C29 9.05974 28.6222 9.4375 28.1562 9.4375C27.6903 9.4375 27.3125 9.05974 27.3125 8.59375V3.53125C27.3125 3.06526 26.9347 2.6875 26.4688 2.6875H21.4062C20.9403 2.6875 20.5625 2.30974 20.5625 1.84375Z",
    fill: "#FFBB38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 19.5625C3.30974 19.5625 3.6875 19.9403 3.6875 20.4062V25.4688C3.6875 25.9347 4.06526 26.3125 4.53125 26.3125H9.59375C10.0597 26.3125 10.4375 26.6903 10.4375 27.1562C10.4375 27.6222 10.0597 28 9.59375 28H4.53125C3.13328 28 2 26.8667 2 25.4688V20.4062C2 19.9403 2.37776 19.5625 2.84375 19.5625Z",
    fill: "#FFBB38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1562 19.5625C28.6222 19.5625 29 19.9403 29 20.4062V25.4688C29 26.8667 27.8667 28 26.4688 28H21.4062C20.9403 28 20.5625 27.6222 20.5625 27.1562C20.5625 26.6903 20.9403 26.3125 21.4062 26.3125H26.4688C26.9347 26.3125 27.3125 25.9347 27.3125 25.4688V20.4062C27.3125 19.9403 27.6903 19.5625 28.1562 19.5625Z",
    fill: "#FFBB38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0625 24.625C7.0625 24.625 5.375 24.625 5.375 22.9375C5.375 21.25 7.0625 16.1875 15.5 16.1875C23.9375 16.1875 25.625 21.25 25.625 22.9375C25.625 24.625 23.9375 24.625 23.9375 24.625H7.0625Z",
    fill: "#FFBB38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 9.4375C20.5625 12.2334 18.2959 14.5 15.5 14.5C12.7041 14.5 10.4375 12.2334 10.4375 9.4375C10.4375 6.64156 12.7041 4.375 15.5 4.375C18.2959 4.375 20.5625 6.64156 20.5625 9.4375Z",
    fill: "#FFBB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonTeachingStaff);
export default __webpack_public_path__ + "static/media/non-teaching-staff.9ee16b81cf7c26e702bfff8476055f99.svg";
export { ForwardRef as ReactComponent };